module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/sakae_point3_4-fddf78b00149d2000349ff78c7211ad3.jpg";